"use strict"

import BreadcrumbService from "../../services/breadcrumb-service/breadcrumb.service"
import LogRocketService from "../../services/log-rocket/log-rocket.service"

export default class SignupChoiceController {
  /**
   * @param {BreadcrumbService} BreadcrumbService
   * @param {LogRocketService} LogRocketService
   */
  constructor(BreadcrumbService, LogRocketService) {
    "ngInject"

    /** @type {BreadcrumbService} */
    this._breadcrumbService = BreadcrumbService
    /** @type {LogRocketService} */
    this._logRocketService = LogRocketService

    this._isLoading = false
  }

  /**
   * @return {boolean}
   */
  get isLoading() {
    return this._isLoading
  }

  goBack() {
    this._breadcrumbService.goBack("root.login")
  }

  goToCreateTeacherAccount() {
    this._breadcrumbService.go("root.signup-teacher")
  }

  goToProInviteStudent() {
    this._breadcrumbService.go("root.signup-student")
  }
}
